export const CREATE_PETROL_EXPENSE = "CREATE_PETROL_EXPENSE";
export const FETCH_PETROL_EXPENSES = "FETCH_PETROL_EXPENSES";
export const FETCH_PETROL_EXPENSE = "FETCH_PETROL_EXPENSE";
export const EDIT_PETROL_EXPENSE = "EDIT_PETROL_EXPENSE";
export const DELETE_PETROL_EXPENSE = "DELETE_PETROL_EXPENSE";
